import { Button, Divider, Input, message, Spin } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, {
  FormEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { MdAdd, MdClose } from 'react-icons/md';
import { useHistory, useParams } from 'react-router-dom';
import Layout from '../../../components/Layout';
import api from '../../../services/api';

import { Container, AddForm } from './styles';

interface Category {
  _id: string;
  name: string;
  description: string;
}

const CategoriesForm: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState<Category>({} as Category);
  const [isUpdating, setIsUpdating] = useState(false);

  const nameRef = useRef<Input>(null);
  const descriptionRef = useRef<TextArea>(null);

  const history = useHistory();
  const { id } = useParams() as { id: string };

  useEffect(() => {
    async function loadData(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get(`categories/${id}`);

        setCategory(response.data);
      } catch (err) {
        message.error('Erro ao carregar dados');
      } finally {
        setLoading(false);
      }
    }

    if (id !== 'add') {
      loadData();
      setIsUpdating(true);
    }
  }, [id]);

  const handleAddCategory = useCallback(() => {
    setLoading(true);

    api
      .post('categories', {
        name: nameRef.current?.input.value,
        description: descriptionRef.current?.state.value,
      })
      .then(() => {
        message.success('Categoria criada com sucesso');
        history.push('/categories');
      })
      .catch(() => message.error('Erro ao criar categoria'))
      .finally(() => setLoading(false));
  }, [history]);

  const handleUpdateCategory = useCallback(() => {
    setLoading(true);

    api
      .put(`categories/${id}`, {
        name: nameRef.current?.input.value,
        description: descriptionRef.current?.state.value,
      })
      .then(() => {
        message.success('Categoria atualizada com sucesso');
        history.push('/categories');
      })
      .catch(() => message.error('Erro ao atualizar categoria'))
      .finally(() => setLoading(false));
  }, [history, id]);

  const handleSubmit = (e: FormEvent): void => {
    e.preventDefault();

    if (isUpdating) {
      handleUpdateCategory();
    } else {
      handleAddCategory();
    }
  };

  if (loading) {
    return (
      <Layout title="Categorias">
        <Spin style={{ marginTop: '50%' }} size="large" />
      </Layout>
    );
  }

  return (
    <Layout title="Categorias">
      <Container>
        <h2>{isUpdating ? 'Atualizar' : 'Adicionar'}</h2>

        <AddForm onSubmit={handleSubmit}>
          <div className="input-group">
            <h4>Nome</h4>
            <Input ref={nameRef} type="text" defaultValue={category.name} />
          </div>

          <div className="inputs-group">
            <div className="input-group">
              <h4>Descrição</h4>
              <TextArea
                ref={descriptionRef}
                defaultValue={category.description}
              />
            </div>
          </div>

          <Divider />

          <div className="button-group">
            <Button
              icon={<MdClose />}
              type="primary"
              danger
              onClick={() => history.goBack()}
            >
              Cancelar
            </Button>
            <Button icon={<MdAdd />} type="primary" htmlType="submit">
              {isUpdating ? 'Atualizar' : 'Adicionar'}
            </Button>
          </div>
        </AddForm>
      </Container>
    </Layout>
  );
};

export default CategoriesForm;
